import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import moment from "moment";
import DialogModal from "../../common/DialogModal";
import Loader from "../../Parts/Loader";
import Pagination from "../../common/Pagination";
import { addCommas } from "../../../utils/utils";
import { DOWNLOAD_HISTORY_DETAIL_PER_PAGE } from "../../../constants/Constants";
import {
  getDetailPersonName,
  getDetailCompany,
  getDetailHonorific,
} from "../../../utils/downloadHistoryUtils";

const styles = () => ({
  // ダイアログ内に収め、テーブルだけをスクロールさせるための縦並びコンテナ
  content: {
    display: "flex",
    flexDirection: "column",
    // ヘッダー(タイトル)・余白を差し引いてダイアログを画面内に収める
    maxHeight: "calc(100vh - 200px)",
  },

  summary: {
    flexShrink: 0,
    fontSize: 13,
    color: "#71737B",
    marginBottom: 16,
    textAlign: "left",
  },

  // 明細テーブルのスクロール領域（件数が多くてもこの中だけがスクロールする）
  tableScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13,
    background: "#FFFFFF",
  },

  th: {
    // スクロールしても列見出しを残す
    position: "sticky",
    top: 0,
    zIndex: 1,
    background: "#FFFFFF",
    textAlign: "left",
    padding: "10px 12px",
    borderBottom: "1px solid #00000026",
    color: "#71737B",
    whiteSpace: "nowrap",
  },

  td: {
    textAlign: "left",
    padding: "10px 12px",
    borderBottom: "1px solid #00000026",
  },

  tdRight: {
    textAlign: "right",
    padding: "10px 12px",
    borderBottom: "1px solid #00000026",
    whiteSpace: "nowrap",
  },

  // ローディング/明細なしの表示をダイアログボディ中央に配置するための領域
  stateContainer: {
    height: "calc(100vh - 200px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  empty: {
    color: "#71737B",
  },

  paginationContainer: {
    flexShrink: 0,
    margin: "24px 0px 8px 0px",
  },
});

class DownloadHistoryDetailDialog extends React.Component {
  renderContent = () => {
    const { classes, detail, isLoading, order, pageInfo } = this.props;

    if (isLoading) {
      return (
        <div className={classes.stateContainer}>
          <Loader type="color" size="large" />
        </div>
      );
    }

    if (!detail || detail.length === 0) {
      return (
        <div className={classes.stateContainer}>
          <div className={classes.empty}>明細はありません。</div>
        </div>
      );
    }

    return (
      <div className={classes.content}>
        {order && (
          <div className={classes.summary}>
            ダウンロード者: {order.ownership_user_name || "-"}
            {"　"}ダウンロード日時: {moment(order.instructed_at).format("YYYY/MM/DD HH:mm")}
            {"　"}件数: {addCommas(order.export_count)}件
          </div>
        )}
        <div className={classes.tableScroll}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th className={classes.th}>氏名</th>
                <th className={classes.th}>会社</th>
                <th className={classes.th}>役職</th>
              </tr>
            </thead>
            <tbody>
              {detail.map(row => (
                <tr key={row.id}>
                  <td className={classes.td}>{getDetailPersonName(row)}</td>
                  <td className={classes.td}>{getDetailCompany(row)}</td>
                  <td className={classes.td}>{getDetailHonorific(row)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {pageInfo && pageInfo.last_page > 1 && (
          <div className={classes.paginationContainer}>
            <Pagination
              currentPage={pageInfo.current_page}
              lastPage={pageInfo.last_page}
              total={pageInfo.total}
              perPage={DOWNLOAD_HISTORY_DETAIL_PER_PAGE}
              showLastPage={true}
              disabled={isLoading}
              onChange={(data) => {
                this.props.onChangePage({
                  page: data.page,
                  per_page: data.per_page,
                });
              }}
            />
          </div>
        )}
      </div>
    );
  };

  render() {
    return (
      <DialogModal
        open={this.props.isOpen}
        onClose={this.props.onClose}
        title="ダウンロード明細"
        fullWidth={true}
        maxWidth="md"
      >
        {this.renderContent()}
      </DialogModal>
    );
  }
}

DownloadHistoryDetailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  order: PropTypes.object,
  detail: PropTypes.array,
  pageInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  onChangePage: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(DownloadHistoryDetailDialog);



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/dialogs/DownloadHistoryDetailDialog.jsx